import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

import UserScreen from "./screens/Users";
import EditUserScreen from "./screens/EditUser";

const UserRouter = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <UserScreen />
      </Route>
      <Route path={`${path}/:userId`}>
        <EditUserScreen />
      </Route>
    </Switch>
  );
};

export default UserRouter;
